/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import WOW from 'wowjs'
import {
  Profile_Link_Box,
  Header,
  Footer,
  ModalBox,
} from '../../components/index'
import { ClearToken } from '../../utilities/tokenSetting'
import { IoMdLogOut } from 'react-icons/io'

const Profile = () => {
  const [modal, setModal] = useState(false)
  useEffect(() => {
    new WOW.WOW().init()
  }, [])

  return (
    <>
      <Header title='پروفایل کاربری' />
      <div className='container'>
        <div className='template-pages'>
          <Row>
            {/* <Col xs={12} md={6}>
              <Profile_Link_Box
                icon={<AiOutlineFile size={20} />}
                title={'دریافتی ها'}
                notficate={NumberWithCommas(9403900000)}
                animate={'fadeInUp'}
              />
            </Col> */}
            <Col xs={12} md={6}>
              <Profile_Link_Box
                icon={<img src='/svg/Light/Buy.svg' alt='buy' />}
                title={'خرید های من'}
                animate={'fadeInUp'}
                link={'/product-list'}
              />
            </Col>
            <Col xs={12} md={6}>
              <Profile_Link_Box
                icon={<img src='/svg/Light/Work.svg' alt='work' />}
                title={'خدمات درحال انجام'}
                notficate={'خدمات'}
                animate={'fadeInUp'}
                link={'/services/pending'}
                linkNotficate={'/service'}
              />
            </Col>
            <Col xs={12} md={6}>
              <Profile_Link_Box
                icon={<img src='/svg/Light/Shield Done.svg' alt='Shield' />}
                title={'خدمات انجام شده'}
                notficate={'خدمات'}
                animate={'fadeInUp'}
                link={'/services/complete'}
                linkNotficate={'/service'}
              />
            </Col>
            <Col xs={12} md={6}>
              <Profile_Link_Box
                icon={<img src='/svg/Light/Profile.svg' alt='Profile' />}
                title={'اطلاعات شخصی'}
                notficate={'ویرایش کنید'}
                animate={'fadeInUp'}
                link={'/profile/edit'}
              />
            </Col>
            <Col xs={12} md={6}>
              <Profile_Link_Box
                icon={<img src='/svg/Light/Folder.svg' alt='floder' />}
                title={'پرونده ها'}
                animate={'fadeInUp'}
                link={'/profile/documents'}
              />
            </Col>
            <Col xs={12} md={6}>
              <Profile_Link_Box
                icon={<img src='/svg/Light/Wallet.svg' alt='wallet' />}
                title={'تراکنش های رزرو شده'}
                linkNotficate={'/'}
                animate={'fadeInUp'}
                link={'/profile/consultings'}
              />
            </Col>

            {/* <Col xs={12} md={6}>
              <Profile_Link_Box
                icon={<AiOutlineComment size={20} />}
                title={'نظرات کاربران'}
                notficate={'بررسی کنید'}
                animate={'fadeInUp'}
              />
            </Col> */}
            {/* <Col xs={12} md={6}>
              <Profile_Link_Box
                icon={<FaRegHandshake size={20} />}
                title={'قرار دادها'}
                notficate={'مورد جدید'}
                animate={'fadeInUp'}
              />
            </Col> */}

            <Col xs={12} md={6}>
              <Profile_Link_Box
                icon={<img src='/svg/Light/Wallet.svg' alt='Wallet' />}
                title={'تراکنش پرونده ها '}
                animate={'fadeInUp'}
                link={'/document/transaction'}
              />
            </Col>
            <Col xs={12} md={6}>
              <Profile_Link_Box
                icon={<img src='/svg/Light/Paper.svg' alt='paper' />}
                title={'کتابخانه'}
                animate={'fadeInUp'}
                link={'/library'}
              />
            </Col>

            <Col xs={12} md={6}>
              <Profile_Link_Box
                icon={<img src='/svg/Light/Ticket.svg' alt='ticket' />}
                title={'پشتیبان آنلاین'}
                animate={'fadeInUp'}
                link={'https://talk.imber.live/1mp9fpkl0rkx31sx7h'}
                notficate={'ایجاد تیکت'}
                outLink={true}
              />
            </Col>
            <ModalBox
              show={modal}
              onHide={() => setModal(false)}
              title={'آیا میخواهیدازحساب کاربری خارج شوید؟'}
            >
              <div className='text-center d-flex justify-content-center'>
                <button className='btn-1' onClick={() => setModal(false)}>
                  خیر
                </button>
                <button className='btn-1' onClick={() => ClearToken()}>
                  بله
                </button>
              </div>
            </ModalBox>
            <Col xs={12} md={6}>
              <div
                className='profile-link-box wow fadeInUp'
                onClick={() => setModal(!modal)}
              >
                <div>
                  <IoMdLogOut size={24} color={'#252580'} />
                </div>
                <div className='title'>خروج</div>
                <div></div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <Footer />
    </>
  )
}
export default Profile
